export default __webpack_public_path__ + "static/media/EmptyCard.d8cf5f65.svg";